import { useAvailableTimes } from "api/api-hooks/use-available-times";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useBookingStateContext } from "hooks/use-booking-state";
import { useMemo } from "react";
import { AvailableTimesSection, AvailableTimesUnit } from "types/available-times";

export const useAllTimeSets = () => {
    const state = useBookingStateContext();
    const { data: reservation } = useWebBooking();
    const date = state.date ?? reservation?.start.clone().startOf("day");
    const availableTimes = useAvailableTimes(date);

    return useMemo(() => {
        return availableTimes?.data?.flatMap((item: AvailableTimesUnit) => [
            ...item.sections.flatMap((section: AvailableTimesSection) => section.timeSets),
            ...item.experiences.flatMap((experience) =>
                experience.activities.flatMap((activity) => activity.timeSets)
            ),
        ]);
    }, [availableTimes?.data]);
};
